import React, { useState } from "react";
import Sidebar from "../../../components/sidebar";
import { useOutletContext } from "react-router-dom";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import DollorIcon from "../../../icons/DollorIcon";
import HistoryIcon from "../../../icons/HistoryIcon";
import SettingIcon from "../../../icons/SettingIcon";
import "./style.scss";
import OverviewTab from "../../../core/components/billingAndSubscriptionTabs/OverviewTab";
import PaymentTab from "../../../core/components/billingAndSubscriptionTabs/PaymentTab";
import HistoryTab from "../../../core/components/billingAndSubscriptionTabs/History";
import SettingsTab from "../../../core/components/billingAndSubscriptionTabs/SettingsTab";

const NonRealBillingAndSubscription = () => {
  const { isSidebarOpen, onToggleSidebar } = useOutletContext<{ isSidebarOpen: boolean; onToggleSidebar: () => void }>();

  const [activeTab, setActiveTab] = useState<string>("Overview");


  return (
    <div className="layout">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Main Content */}
      <main className="content dashboardPageWrapper">

        <div className="profileSettings billing-subscription-page">
          <div className="title_btn d-flex justify-content-between gap-2 flex-wrap align-items-center">
            <div>
              <h2>Billing & Subscription</h2>
              <p>
                Manage your subscription, payment methods, and billing history
              </p>
            </div>
          </div>

          <div className="tab-wrapper mt-3">
            <Tab.Container
              id="left-tabs-example"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k || "Overview")}
            >
              <Row>
                <Col sm={12}>
                  <Nav variant="pills" className="d-flex gap-2">
                    <Nav.Item>
                      <Nav.Link eventKey="Overview"><DollorIcon /> Overview</Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                      <Nav.Link eventKey="Payment"><DollorIcon />  Payment</Nav.Link>
                    </Nav.Item> */}
                    <Nav.Item>
                      <Nav.Link eventKey="History"><HistoryIcon /> History</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Settings"><SettingIcon /> Settings</Nav.Link>
                    </Nav.Item>

                  </Nav>
                </Col>

                <Col sm={12}>
                  <Tab.Content>
                    <Tab.Pane eventKey="Overview">
                      <OverviewTab
                        activeTab={activeTab}
                        onNavigateToTab={setActiveTab}
                      />
                    </Tab.Pane>
                    {/* <Tab.Pane eventKey="Payment"><PaymentTab /></Tab.Pane> */}
                    <Tab.Pane eventKey="History">
                      <HistoryTab
                        activeTab={activeTab}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="Settings">
                      <SettingsTab
                        onNavigateToTab={setActiveTab}
                        activeTab={activeTab}
                      />
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>

      </main>
    </div>
  );
};

export default NonRealBillingAndSubscription;
